const cards = [
  {
    title: '热门电影推荐',
    desc: '精选豆瓣高分、票房热门电影，涵盖动作冒险、科幻巨制、温情喜剧等全类型，每周更新最新院线大片资源。',
    image: 'https://readdy.ai/api/search-image?query=Movie%20theater%20lobby%20with%20warm%20golden%20lighting%2C%20film%20posters%20on%20wall%2C%20rich%20crimson%20and%20amber%20tones%2C%20cinematic%20atmosphere%2C%20elegant%20design%2C%20no%20people%2C%20subtle%20film%20reel%20decor%2C%20warm%20and%20inviting%20mood&width=800&height=500&seq=card-hot-movies&orientation=landscape',
    tag: '电影',
  },
  {
    title: '热播电视剧连载',
    desc: '国内热门电视剧免费全集持续更新，都市情感、古装权谋、悬疑探案等爆款剧集一网打尽，追剧不等待。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20living%20room%20home%20theater%20setup%20with%20large%20TV%20screen%2C%20cozy%20warm%20lighting%2C%20comfortable%20sofa%2C%20amber%20and%20brown%20color%20scheme%2C%20cinematic%20feel%2C%20elegant%20interior%20design%2C%20no%20people%2C%20warm%20atmosphere&width=800&height=500&seq=card-tv-series&orientation=landscape',
    tag: '电视剧',
  },
  {
    title: '综艺娱乐合集',
    desc: '热门综艺节目全收录，音乐竞演、真人秀、脱口秀、生活纪实等多元综艺内容，轻松愉悦享不停。',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20stage%20with%20colorful%20warm%20spotlights%2C%20golden%20and%20amber%20lighting%20effect%2C%20music%20show%20atmosphere%2C%20elegant%20performance%20venue%2C%20cinematic%20composition%2C%20rich%20warm%20tones%2C%20no%20performers%2C%20professional%20stage%20design&width=800&height=500&seq=card-variety&orientation=landscape',
    tag: '综艺',
  },
  {
    title: '动漫动画专区',
    desc: '国内外精品动漫动画资源，日漫经典、国漫崛起、欧美动画等高清画质，二次元爱好者专属观影频道。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20animation%20studio%20workspace%20with%20warm%20ambient%20lighting%2C%20drawing%20tablet%20and%20sketches%2C%20golden%20and%20soft%20brown%20tones%2C%20creative%20atmosphere%2C%20cinematic%20lighting%2C%20cozy%20artistic%20vibe%2C%20minimalist%20composition&width=800&height=500&seq=card-anime&orientation=landscape',
    tag: '动漫',
  },
  {
    title: '纪录片频道',
    desc: '自然探索、历史人文、科技前沿等高品质纪录片，带您领略世界万象，开阔视野增长见识。',
    image: 'https://readdy.ai/api/search-image?query=Exploration%20and%20nature%20documentary%20concept%2C%20warm%20earth%20tones%2C%20cinematic%20landscape%20photography%20style%2C%20golden%20hour%20lighting%2C%20vast%20natural%20scenery%2C%20rich%20amber%20and%20brown%20colors%2C%20elegant%20composition%2C%20awe%20inspiring%20atmosphere&width=800&height=500&seq=card-documentary&orientation=landscape',
    tag: '纪录片',
  },
  {
    title: '少儿内容精选',
    desc: '寓教于乐的少儿动画与儿童节目，安全健康的观影环境，启蒙教育娱乐两不误，家长放心的选择。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20children%20playroom%20with%20warm%20golden%20lighting%2C%20colorful%20educational%20toys%2C%20soft%20carpet%20and%20cushions%2C%20amber%20and%20cream%20color%20palette%2C%20warm%20inviting%20atmosphere%2C%20cinematic%20composition%2C%20no%20children%2C%20elegant%20interior&width=800&height=500&seq=card-kids&orientation=landscape',
    tag: '少儿',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            精选内容推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            六大内容板块，海量高清影视资源免费在线观看，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <article
              key={card.title}
              className="group bg-white rounded-xl overflow-hidden border border-background-200/70 hover:shadow-md transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-48 md:h-52">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-md text-xs font-medium bg-primary-500 text-white">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}